// @core/api/endpoints/calendar/respond_to_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
  RespondToInvitationRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Respond to invitation
 * Records the current user's RSVP response (accepted, declined, tentative) with an optional comment. The organizer is notified of the response.
 */
export async function RespondToInvitation(
  event_id: string,
  data: RespondToInvitationRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/respond`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
